import Record from "./Record.js";
import Tuple from "./Tuple.js";
function RecordTuple(input) {
    return (Array.isArray(input) ? Tuple.from(input) : Record(input));
}
RecordTuple.deep = (input) => {
    if (!input || typeof input !== "object")
        throw new Error(`RecordTuple.deep: Invalid input ${input}`);
    if (Tuple.isTuple(input) || Record.isRecord(input))
        return input;
    if (Array.isArray(input))
        return Tuple.from(input.map((item) => item && (typeof item === "object" ? RecordTuple.deep(item) : item)));
    return Record.fromEntries(Object.entries(input).map(([k, v]) => [
        k,
        v && (typeof v === "object" ? RecordTuple.deep(v) : v),
    ]));
};
export default RecordTuple;
